var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.231 1.923a5.04 5.04 0 0 1-1.58.588 2.513 2.513 0 0 0-1.82-.764 2.454 2.454 0 0 0-2.486 2.42c0 .187.024.373.068.555A7.135 7.135 0 0 1 1.278 2.19a2.36 2.36 0 0 0-.337 1.214A2.4 2.4 0 0 0 2.05 5.42a2.525 2.525 0 0 1-1.128-.3v.03a2.44 2.44 0 0 0 1.993 2.374 2.55 2.55 0 0 1-1.124.042 2.485 2.485 0 0 0 2.326 1.682 5.08 5.08 0 0 1-3.092 1.04 5.153 5.153 0 0 1-.592-.04 7.188 7.188 0 0 0 3.814 1.09 6.933 6.933 0 0 0 7.082-6.89c0-.104 0-.208-.007-.312a4.98 4.98 0 0 0 1.245-1.254 5.042 5.042 0 0 1-1.43.382 2.436 2.436 0 0 0 1.094-1.34z",
    fill: "#1D9BF0",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.10494655.svg";
export { ForwardRef as ReactComponent };